





































































































import {Component, Prop, PropSync, Watch} from 'vue-property-decorator';
import Vue from 'vue';
import {AdminSectionField} from "@/models/AdminForms";

@Component
export default class AdminSection extends Vue {
	@Prop() title!: string;
	@Prop() subtitle!: string;
	@Prop() data!: AdminSectionField[];
	@PropSync('anyActive') editActive!: boolean;
	@Prop({ default: false, type: Boolean }) noAutoClose!: boolean;
	@Prop({ default: false, type: Boolean }) valid!: boolean;
	@Prop({ default: false, type: Boolean }) editOnly!: boolean;
	@Prop({ default: false, type: Boolean }) toggleable!: boolean;
	@Prop({ default: false, type: Boolean }) noSubmit!: boolean;
	@PropSync('closed') closedSync!: boolean;

	editMode = false;

	mounted(): void {
		if (this.editOnly) {
			this.edit();
		}
	}

	@Watch('editOnly')
	editOnlyChanged(newValue: boolean): void {
		if (newValue) {
			this.edit();
		}
	}

	edit(): void {
		this.editMode = true;
		this.editActive = true;
		this.$emit('edit');
	}

	submit(): void {
		if (!this.noAutoClose) this.editMode = false;
		this.$emit('submit');
	}

	cancel(): void {
		this.editMode = false;
		this.$emit('cancel');
	}

	close(): void {
		this.editMode = false;
	}
}
